import { StyledTableHead } from './styles';

export const TableHead = StyledTableHead;

export default TableHead;
